export function init() {
  const forms = Array.from(document.querySelectorAll("form[id^=address]"));

  for (let form of forms) {
    const allInputs = Array.from(form.querySelectorAll("input[id^=Address]"));
    const allSelects = Array.from(form.querySelectorAll("select"));
    for (let input of allInputs) {
      const label = input.parentElement.querySelector("label");
      if (!label) return;
      if (!(input instanceof HTMLInputElement)) return;

      if (input.value !== "") {
        label.classList.add("label-small");
      }
      input.addEventListener("focus", () => {
        label.classList.add("label-small");
      });
    }
    for (let select of allSelects) {
      // Select is wrapped in div
      const label = select.closest("div").parentElement.querySelector('label');
      if (!label) return;
      if (!(select instanceof HTMLSelectElement)) return;

      select.addEventListener("focus", () => {
        label.classList.add("label-small");
      });
      if (select.value !== "" && select.value !== "---") {
        label.classList.add("label-small");
      }


      // If the country is empty should prevent submit (because it returns an error)
      const form = select.closest("form");
      const updateButton = form.querySelector("button.button--update");
      const addButton = form.querySelector("button.button--add");
      if (select && select.name == "address[country]") {

        // On first load
        if (select.value == "---" || select.value == "") {
          form.addEventListener("submit", preventSubmit);
          //console.log("country can't be empty", select.value);

          // Disable submit(add or update) button
          if (updateButton) {
            updateButton.disabled = true;
          }
          if (addButton) {
            addButton.disabled = true;
          }
        } else {
          form.removeEventListener("submit", preventSubmit);
          if (updateButton) {
            updateButton.disabled = false;
          }
          if (addButton) {
            addButton.disabled = false;
          }
        }

        // After
        select.addEventListener("change", (e) => {
          if (select.value == "---" || select.value == "") {
            form.addEventListener("submit", preventSubmit);
            // console.log("country can't be empty");
            select.style.border = "1px solid var(--brand-red)";
            if (updateButton) {
              updateButton.disabled = true;
            }
            if (addButton) {
              addButton.disabled = true;
            }
          } else {
            form.removeEventListener("submit", preventSubmit);
            select.style.border = "1px solid black";
            if (updateButton) {
              updateButton.disabled = false;
            }
            if (addButton) {
              addButton.disabled = false;
            }
          }
        });
      }
    }
  }
}
function preventSubmit(e) {
  e.preventDefault();
}
